import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';
import { Box, Link, Text } from '@opendoor/bricks-next';
import { IconChevronRight } from '@tabler/icons-react';

import type { MenuLink } from '../../types';

interface MenuCTAProps {
  ctaLink?: MenuLink;
  ctaTitle?: string;
  open: boolean;
}

export const MenuCTA: React.FC<MenuCTAProps> = ({ ctaLink, ctaTitle, open }) => {
  if (!ctaLink?.name || !ctaLink?.href) return null;

  return (
    <Col
      className={cn(
        'w-full px-6 py-4 transition-opacity duration-300 ease-linear',
        open ? 'opacity-100 delay-300' : 'opacity-0',
      )}
    >
      <Link
        href={ctaLink.href}
        aria-label={ctaLink.name}
        analyticsName={`cosmos-landing-page-v2-menu-cta-link-${ctaLink.name}`}
        backgroundColor="$backgroundSecondary"
        borderRadius="$8x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingTop="$8x"
        paddingBottom="$8x"
        paddingLeft="$10x"
        paddingRight="$10x"
        textDecorationLine="none"
      >
        <Box>
          {ctaTitle && (
            <Text tag="span" display="block" typography="$labelSmall" color="$contentPrimary">
              {ctaTitle}
            </Text>
          )}
          <Text tag="span" display="block" typography="$bodySmall" color="$contentSecondary">
            {ctaLink.name}
          </Text>
        </Box>
        <Text tag="span" typography="$bodySmall" color="$contentPrimary">
          <IconChevronRight size={24} />
        </Text>
      </Link>
    </Col>
  );
};
